import {useState,useEffect,useRef,useCallback} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import styles from './AIDemo.module.css'
import {useSquatLeaderboard} from './hooks'
import {capitalize} from '../../util/util'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import useWindowSize from '../../hooks/useWindowSize'
import {
	removeLeaderboardRecord,
	editLeaderboardRecord,
	addLeaderboardRecord,
	setMetricCreator,
	setShow,
	setDemo
} from './slice'
import {
	Line,
	Scatter
} from 'react-chartjs-2'
import * as poseDetection from '@tensorflow-models/pose-detection'
import * as tf from '@tensorflow/tfjs-core'
// Register one of the TF.js backends.
import '@tensorflow/tfjs-backend-webgl'
import store from '../../app/store'
import Webcam from "react-webcam"
import useCountDown from "react-countdown-hook"
import useCurrentUser from '../../hooks/useCurrentUser'
import {
	angleOf as angleOfVector,
	minus as subtractVector
} from 'vector-math-fp'

import {
	dateToYMD
} from '../../util/datetime'

import Guides from './Guides'
import SquatDemo from './SquatDemo'
import Leaderboard from './Leaderboard'
import MetricCreator from './MetricCreator'
import SingleLegSquatDemo from './SingleLegSquatDemo'
import BalanceDemo from './BalanceDemo'
import KneeFlexionDemo from './KneeFlexionDemo'
import CalfRaiseDemo from './CalfRaiseDemo'
import SpineRotationDemo from './SpineRotationDemo'
import ArmOverheadMovement from './ArmOverheadMovement'
import ActiveSeatedKneeExtension from './ActiveSeatedKneeExtension'

import {
	normalizeX,
	repConsistency,
	tempoConsistency,
	depthScore,
	extractRepSlices,
	nonMonotonicIndexes,
	argMin,
	argMax,
	getKneeCaveTimeMap,
	restConsistency,
	kneeArticulationConsistency,
	centerLineConsistency,
	repsCenterLineScore,
	chestCenter,
	hipCenter,
	useAnimationFrame,
	poseFemurLength,
	poseHeight,
	balancingSide,
	calculateCenterStatus,
	calculateShoulderTilt,
	calculateHipTilt,
	tiltScore,
	kneeHeightScore,
	nearest
} from './util'
import HowTo from './HowTo'
import useBranding from '../../hooks/useBranding'

const SCORE_THRESHOLD = 0.7

const detectorConfig = {
	modelType: poseDetection.movenet.modelType.SINGLEPOSE_THUNDER,
	enableTracking: true,
	trackerType: poseDetection.TrackerType.BoundingBox,
}

const AIDemo = ({mode})=>{
	const dispatch = useDispatch()
	const show = useSelector( state => state.ai.show ) || mode === 'webview'
	const [windowWidth,windowHeight] = useWindowSize()
	const showTurnPhoneLandscape = windowWidth < 500
	const [currentDemo,setCurrentDemo] = useState('squat')
	const options = [
		{
			key:'squat',
			text:'Squat'
		},{
			key:'single-leg-squat',
			text:'Single Leg Squat'
		},{
			key:'balance',
			text:'Balance'
		},{
			key:'knee-flexion',
			text:'Knee Flexion'
		},{
			key:'calf-raise',
			text:'Calf Raise'
		},{
			key:'seated-rotational-twist',
			text:'Seated Rotational Twist'
		},{
			key:'arm-overhead-movement',
			text:'Arm Overhead Movement'
		},{
			key:'active-seated-knee-extension',
			text:'Active Seated Knee Extension'
		}
	]

	const branding = useBranding()

	const handleDemoSelect =  e => {
		const demo = e.target.value
		setCurrentDemo(demo)
		dispatch(setDemo(demo))
	}

	//const show = true
	if (!show) return null
	if(showTurnPhoneLandscape) return (
		<div id={styles.AIDemo}>
			<div className="w-100 d-flex align-items-center justify-content-center">
				<strong>For devices this size, rotate to landscape</strong>
			</div>
		</div>
	)
	return (
		<>
			<div id={styles.AIDemo}>
				{ currentDemo === 'squat' && <SquatDemo/> }
				{ currentDemo === 'balance' && <BalanceDemo/> }
				{ currentDemo === 'single-leg-squat' && <SingleLegSquatDemo/> }
				{ currentDemo === 'knee-flexion' && <KneeFlexionDemo/> }
				{ currentDemo === 'calf-raise' && <CalfRaiseDemo/> }
				{ currentDemo === 'seated-rotational-twist' && <SpineRotationDemo/> }
				{ currentDemo === 'arm-overhead-movement' && <ArmOverheadMovement/> }
				{ currentDemo === 'active-seated-knee-extension' && <ActiveSeatedKneeExtension/> }
				<img 
					src={
						branding
						? `${branding.logo}`
						: "https://cdn.fitsw.com/assets/img/brand/FitSW-Personal-Trainer-Software-Logo-For-Fitness-Coaches-Blue.png"
					}
					style={{
						position:'absolute',
						top:8, left:8,
						width:'160px'
					}}
				/>
				<div 
					className="bg-white py-1 px-3" 
					style={{
						position:'absolute',
						bottom:0, right:0,
						zIndex:10000
					}}
				>
					<div 
						style={{maxWidth:windowWidth<=600?'180px':'auto'}} 
						className={windowWidth<=600?"d-flex flex-column":"d-flex align-items-center"}>
						<div style={{flex:'0 0 auto'}} className="mr-2">Pick Demo:</div>
						<Form.Control 
							onChange={handleDemoSelect}
							value={currentDemo} 
							as="select"
							custom
						>
							{options.map(opt=>(
								<option value={opt.key} key={opt.key}>
									{opt.text}
								</option>
							))}
						</Form.Control>
					</div>
					<div style={{maxWidth:windowWidth<=600?'180px':'auto'}}>
						<small className="d-block">Want another movement? <a href="mailto:support@fitsw.com?subject=Fitsw.ai Movement Request">contact support</a></small>
					</div>
				</div>
			</div>
			<MetricCreator/>
		</>
	)
}

export default AIDemo